"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var VideoCameraOnFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_VideoCameraOnFill_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 16,
    height: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.022 10.618 1.479 1.233c.363.302.544.453.69.49a.653.653 0 0 0 .743-.349c.066-.135.066-.371.066-.843V4.81c0-.472 0-.708-.066-.843a.653.653 0 0 0-.743-.348c-.146.036-.327.187-.69.49l-1.48 1.232c-.24.2-.361.301-.458.416a1.71 1.71 0 0 0-.377.805c-.026.148-.026.305-.026.619v1.596c0 .314 0 .471.026.619.053.297.183.574.377.805.097.115.218.215.459.416ZM0 5.192c0-.592 0-.888.115-1.115.102-.199.263-.36.462-.462C.804 3.5 1.1 3.5 1.692 3.5H7.09c1.55 0 2.326 0 2.919.302.52.265.945.69 1.21 1.21.302.593.302 1.368.302 2.92v2.836c0 .592 0 .888-.115 1.114-.102.2-.263.361-.462.463-.227.115-.523.115-1.115.115H4.43c-1.55 0-2.326 0-2.919-.302a2.77 2.77 0 0 1-1.21-1.21C0 10.355 0 9.58 0 8.028V5.193Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_VideoCameraOnFill_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = VideoCameraOnFill;
exports["default"] = _default;